import Swiper, { Navigation, Pagination, Scrollbar, Autoplay, FreeMode, EffectFade } from 'swiper';
import { $qs, $qsa } from '../../utils/QuerySelector';
import gsap from 'gsap';



function testimonials() {

  const testimonials = $qsa("[data-name='testimonials']");
  const controls = $qsa("[data-name='testimonial-control']");
  // const mobileControls = $qsa("[data-name='testimonial-control-mobile']");
  const animatedCircles = $qsa('[data-name="testimonial-animated-circle"]');
  const animatedCircle = $qs('[data-name="testimonial-animated-circle"]');
  // const animatedCirclesContain = $qs('[data-name="animated-circles"]');

  if (!testimonials) return;

var swiper = new Swiper("[data-name='testimonials']", {
    modules: [Navigation, Scrollbar, Autoplay, FreeMode, Pagination, EffectFade],
    loop: true,
    slidesPerView: 1,
    effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  navigation: {
    nextEl: '.testimonial-swiper-button-next',
    prevEl: '.testimonial-swiper-button-prev',
  },
    // autoplay: {
    //     delay: 5000,
    //     disableOnInteraction: true
    // },
    // navigation: {
    //     nextEl: '[data-name="testimonials"] .swiper-button-next',
    //     prevEl: '[data-name="testimonials"] .swiper-button-prev',
    //   },
 
     });
// var mobileSwiper = new Swiper("[data-name='testimonial-control-mobile']", {
//     modules: [Navigation, Scrollbar, Autoplay, FreeMode, Pagination, EffectFade],
//     loop: true,
//     slidesPerView: 1,
//     centeredSlides: true,
//     loopedSlides: 2,
//     slideToClickedSlide: true,
//     // effect: 'fade',

 
//      });

     swiper.on('slideChange', function () {
      // console.log('slide changed');
      // console.info(this.activeIndex);
      [...controls].forEach((control) => {
        if(this.activeIndex == control.dataset.value){
          control.classList.add('opacity-100')
          control.classList.remove('opacity-20')
        }else{
          control.classList.add('opacity-20')
          control.classList.remove('opacity-100')
        }
      
  
       })
    });

     [...controls].forEach((control) => {
      control.addEventListener('click', () => {
        // console.info('click test:' );
      swiper.slideTo(control.dataset.value, '600',);
      })
      control.addEventListener('mouseover', () => {
        gsap.to(animatedCircle,{x:0, y: 0})

      })

     })


    if (!animatedCircles) return;

    [...animatedCircles].forEach((animatedCircle) => {
       

        $qs('body').addEventListener('mousemove', (e) => {
          if (e.target.dataset.name != 'testimonial-control' && e.target.parentNode.dataset.name != 'testimonial-control') {

            // const cursor = e.target.parentNode.querySelector('.cursor-content');
            let x = e.clientX;
            let y = e.clientY;
            let distance = 80;
            // console.info('animatedCirclesContainX:' + animatedCirclesContainX);
            // console.info('animatedCirclesContainY:' + animatedCirclesContainY);
            x = x - screen.width/2;
            y = y - screen.height/2;
            x = x / distance;
            y = y / distance;
            // console.info('x:' + x);
            // console.info('y:' + y);
            gsap.to( animatedCircle, { transformOrigin: 'center', x: x, y: y, duration: 0.5 } );
          }else{
            // console.info('no move');
          }

        });


    });
}

    export default testimonials;